export default defineNuxtRouteMiddleware((to, from) => {
  const { $site } = useNuxtApp()

  if ($site?.tabs) {
    const enabled = $site.tabs
    const tabs = to.meta?.tabs as string[] | undefined
    const onlineBookingEnabled = $site.onlineBookingEnabled
    const layout = $site.layout

    if (tabs) {
      for (let i = 0; i < tabs.length; i++) {
        const tab = tabs[i]

        if (tab === 'online' && onlineBookingEnabled) {
          return
        }

        if (tab in enabled) {
          return
        }
      }

      if (layout === 'widget' || layout === 'facebook') {
        return navigateTo('/widget/disabled')
      }

      if (layout === 'bot') {
        return navigateTo('/bot')
      }

      return navigateTo('/')
    }
  }
})
